import { render, staticRenderFns } from "./ModalSyncVariant.vue?vue&type=template&id=6fa1a48f&"
import script from "./ModalSyncVariant.vue?vue&type=script&lang=js&"
export * from "./ModalSyncVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports